<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">实时数据搜索</span>
                <el-tabs v-model="activeSaleQuery" type="card" @tab-click="onTabClicked">
                  <template v-if="USERMANAGER.isAdmin || !USERMANAGER.isStudyAbroad">
                    <el-tab-pane :key="item.Value" v-for="item in saleQueryList" :label="item.Text"
                      :name="item.NameValue">
                      <salesQueryList :queryData="queryData" :isActive="item.NameValue == activeSaleQuery"
                        :courseType="item.CourseType" :courseTypeText="item.Text" :isInternationalSales="item.IsInternationalSales">
                      </salesQueryList>
                    </el-tab-pane>
                  </template>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss"></style>

<script>
import navigator from "../../components/navigator";
import salesQueryList from "../../components/salesQuery/salesQueryList";

export default {
  data() {
    return {
      activeSaleQuery: "",
      queryData: {},
      hasInternationalSales: false,
      isInternationalSales: false,
      saleQueryList: []
    };
  },
  components: {
    navigator,
    salesQueryList
  },
  created() {
    if (
      !!this.$route.query.studentName &&
      !!this.$route.query.termId &&
      !!this.$route.query.courseType
    ) {
      this.activeSaleQuery = this.$route.query.courseType.toString();
      this.queryData = {
        studentName: this.$route.query.studentName,
        studentId: this.getQueryValue(this.$route.query.studentId),
        courseId: this.getQueryValue(this.$route.query.courseId),
        termId: this.getQueryValue(this.$route.query.termId),
        courseType: this.getQueryValue(this.$route.query.courseType),
        week: this.getQueryValue(this.$route.query.week),
        supplementVideoType: this.getQueryValue(this.$route.query.supplementVideoType),
      };
    } 
    if (this.USERMANAGER.isInternationalSales || this.USERMANAGER.isFinancial
      || this.USERMANAGER.isAdmin || this.USERMANAGER.isRegionCEO
      || this.USERMANAGER.isCampusPresident || this.USERMANAGER.isVocationalTrainingManager
    ){
      this.hasInternationalSales = true;
    }
    let options = this.GLOBAL.courseType.getOptions();
    if (this.USERMANAGER.isVocationalTrainingManager){
      options = options.filter(i => i.value === this.GLOBAL.courseType.vocationalTraining && i.value !== this.GLOBAL.courseType.english);
    }else if (this.USERMANAGER.isAcademicDirector) {
      options = options.filter(i => i.value === this.GLOBAL.courseType.university 
        || i.value === this.GLOBAL.courseType.vocationalTraining);
    }else{
      options = options.filter(i => i.value !== this.GLOBAL.courseType.none && i.value !== this.GLOBAL.courseType.english);
    }
    
    let list = [];
    if (!this.USERMANAGER.isInternationalSales){
      list = options
        .map(item => ({
          CourseType: item.value,
          Value: item.value,
          Text: item.desc,
          NameValue: item.key,
          IsInternationalSales: false
        }));
    }
    if (this.hasInternationalSales){
      let internationalSalesList = options
        .map(item => ({
          CourseType: item.value,
          Value: item.value + 100,
          Text: item.desc + '(国际销售)',
          NameValue: item.key + 'InternationalSales',
          IsInternationalSales: true
        }));
        list.push(...internationalSalesList);
    }

    this.activeSaleQuery = list[0].NameValue;
    this.saleQueryList = list;
  },
  computed: {
 
  },
  methods: {
    getQueryValue(value) {
      if (isNaN(value)) {
        return null;
      } else {
        return parseInt(value);
      }
    },
    onTabClicked() {
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/frontDesk/salesQuery.vue